import React from "react";
import "./Vip_all_details_history.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import No_data from "../Common/No_data/No_data";
import Vip_all_details_history_card from "./Vip_all_details_history_card/Vip_all_details_history_card";

function Vip_all_details_history() {
  return (
    <>
      <section className="Rebate_Ratio Vip_all_details_history">
        <Common_white_header headingText={"Rebate Details"} />
        <div className="container">

          <div className="red_text_heading">
            <h4>[Rebate Rate] Rebate Details</h4>
          </div>
          
          <Vip_all_details_history_card/>
          <Vip_all_details_history_card />
          <Vip_all_details_history_card />
          <Vip_all_details_history_card />
          <Vip_all_details_history_card />

           <No_data/>
        </div>
      </section>
    </>
  );
}

export default Vip_all_details_history;
